<template>
  <v-dialog fullscreen hide-overlay v-model="dialog" overlay-color="#333">
    <template v-slot:activator="{ on, attrs }">
      <slot name="button" :activator="{ on, attrs }" />
    </template>
    <v-card rounded="0">
      <v-row no-gutters justify="start" class="py-10">
        <v-btn text @click="onCancel" :disabled="loading">
          <v-icon class="material-icons">
            arrow_back
          </v-icon>
        </v-btn>
      </v-row>
      <v-row no-gutters justify="center" class="pb-10">
        <h2 class="createReflectionTitle">
          {{ $t('views.reflection.create') }}
        </h2>
      </v-row>
      <ValidationObserver ref="observer" slim v-slot="{ invalid, handleSubmit }">
        <v-form @submit.prevent="handleSubmit(onSubmit)">
          <v-row no-gutters justify="center">
            <v-col cols="5">
              <ValidationProvider v-slot="{ errors }" :name="$t('globals.title').toLowerCase()" rules="required">
                <v-text-field
                  outlined
                  v-model="title"
                  :label="$t('globals.title')"
                  :error-messages="errors"
                  required
                  :disabled="loading"
                />
              </ValidationProvider>
              <v-text-field
                outlined
                v-model="description"
                :label="$t('globals.description')"
                :disabled="loading"
              />
            </v-col>
          </v-row>
          <v-row no-gutters justify="center">
            <v-btn-toggle v-model="template">
              <v-col
                v-for="tpl in allTemplates"
                :key="tpl.name"
                class="templateButton"
                :style="{ '--color': tpl.color }"
              >
                <v-btn text class="templateSquare" :value="tpl">
                  <v-icon :color="tpl.color" size="34" class="material-icons">
                    {{ tpl.icon }}
                  </v-icon>
                </v-btn>
                <p class="text-center pt-3">
                  {{ $t('views.reflection.templateTypes.' + tpl.name) }}
                </p>
              </v-col>
            </v-btn-toggle>
          </v-row>
          <v-row no-gutters justify="center">
            <v-btn
              type="submit"
              elevation="0"
              rounded
              :loading="loading"
              :disabled="invalid"
              color="primary"
              id="reflectionCreateButton"
            >
              {{ $t('actions.create') }}
            </v-btn>
          </v-row>
        </v-form>
      </ValidationObserver>
    </v-card>
  </v-dialog>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { mapActions, mapGetters } from 'vuex';
import { types } from '@/store/rootTypes';

export default {
  name: 'NewReflectionModal',
  components: { ValidationObserver, ValidationProvider },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      description: null,
      dialog: false,
      title: null,
      template: null,
    };
  },
  computed: {
    ...mapGetters({
      allTemplates: types.templates.getters.templates,
    }),
  },
  methods: {
    ...mapActions({
      createReflection: types.reflections.actions.createReflection,
    }),
    onCancel() {
      this.dialog = false;
      this.reset();
    },
    reset() {
      this.description = null;
      this.title = null;
      [this.template] = this.allTemplates;

      this.$refs.observer.reset();
    },
    async onSubmit() {
      this.createReflection(
        {
          title: this.title,
          description: this.description,
          template: this.template,
          acl: [
          ],
        },
      )
        .then((id) => {
          this.dialog = false;
          if (id) {
            this.reset();
            this.$emit('redirect', id);
          }
        });
    },
  },
  watch: {
    allTemplates() {
      if (this.allTemplates.length > 0) {
        [this.template] = this.allTemplates;
      }
    },
  },
};
</script>
<style scoped>
/* Vuetify selectors are aggressive, had to put .templateSquare 4 times */
.templateSquare.templateSquare.templateSquare.templateSquare {
  display: flex;
  height: 153px;
  width: 170px;
  border: 2px solid #EDEDED;
  border-radius: 6px;
  align-items: center;
  justify-content: center;
}

.templateButton .templateSquare.v-btn--active.templateSquare, .templateButton:hover .templateSquare{
  border-color: var(--color) !important;
  border-width: 3px;
}

.templateButton .templateSquare.v-btn--active.templateSquare::before{
  opacity: 0.05;
}

.templateButton {
  cursor: pointer;
  color: #232137;
  font-family: Poppins;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 17px;
}

.createReflectionTitle {
  font-size: 20px;
  font-weight: 600;
}

#reflectionCreateButton {
  padding: 12px 72px;
  font-size: 10.5px;
  font-weight: 600;
  text-transform: capitalize;
}
</style>
